import { render, staticRenderFns } from "./menue.vue?vue&type=template&id=3b6a2197&scoped=true&"
import script from "./menue.vue?vue&type=script&lang=js&"
export * from "./menue.vue?vue&type=script&lang=js&"
import style0 from "./menue.vue?vue&type=style&index=0&id=3b6a2197&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6a2197",
  null
  
)

export default component.exports